/* Oxalis — product page: gallery, quantity stepper, variant selection,
   AJAX add-to-cart, and lazy product recommendations. */
(function () {
  'use strict';

  var root = document.querySelector('[data-product]');
  if (!root) return;
  var productIdAttr = root.getAttribute('data-product-id');

  /* ---------------- Gallery ----------------
     The slides sit side by side in a native horizontal scroll-snap track
     (sections/main-product.liquid) — swiping is the browser's own touch
     scrolling, not custom drag-tracking JS. showMedia() only scrolls to the
     requested slide; an IntersectionObserver watching the track is the
     single source of truth for which slide currently counts as "active"
     (thumb highlight, the "1 / N" counter, and preloading the next image),
     whether the scroll was a manual swipe, a thumbnail click, or a variant
     change swapping the photo. */
  var track = root.querySelector('[data-gallery-track]');
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gallery] .product__gallery-slide'));
  var thumbs = root.querySelectorAll('[data-thumb]');
  var galleryCounter = root.querySelector('[data-gallery-counter]');

  function showMedia(mediaId) {
    var target = slides.filter(function (s) {
      return s.getAttribute('data-media-id') === String(mediaId);
    })[0];
    if (!target || !track) return;
    track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      showMedia(t.getAttribute('data-thumb'));
    });
  });

  if (track && slides.length > 1 && 'IntersectionObserver' in window) {
    var activeIndex = 0;
    var galleryObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.6) return;
          var idx = slides.indexOf(entry.target);
          if (idx === -1 || idx === activeIndex) return;
          activeIndex = idx;

          var mediaId = entry.target.getAttribute('data-media-id');
          thumbs.forEach(function (t) {
            t.classList.toggle('is-active', t.getAttribute('data-thumb') === mediaId);
          });
          if (galleryCounter) galleryCounter.textContent = (idx + 1) + ' / ' + slides.length;

          // Intelligent preload: once a slide is actually being looked at,
          // stop deferring the very next one so the following swipe feels
          // instant, without eagerly loading the whole gallery up front.
          var next = slides[idx + 1];
          var nextImg = next && next.querySelector('img');
          if (nextImg && nextImg.loading === 'lazy') nextImg.loading = 'eager';
        });
      },
      { root: track, threshold: [0.6] }
    );
    slides.forEach(function (s) {
      galleryObserver.observe(s);
    });
  }

  /* ---------------- Quantity ---------------- */
  var qtyInput = root.querySelector('.product__quantity-input input');
  var minus = root.querySelector('[data-qty-minus]');
  var plus = root.querySelector('[data-qty-plus]');
  if (qtyInput && minus && plus) {
    minus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });
    plus.addEventListener('click', function () {
      var next = (parseInt(qtyInput.value, 10) || 1) + 1;
      var max = qtyInput.getAttribute('max');
      // Per-click soft cap only (e.g. a Jonc's max="10") — the real,
      // cart-aware cap (same model already sitting in the cart, across its
      // other finishes) is enforced at add-to-cart time below, since that's
      // the only moment the true existing total is known.
      if (max && next > parseInt(max, 10)) next = parseInt(max, 10);
      qtyInput.value = next;
    });
  }

  /* ---------------- Variants ---------------- */
  var selects = root.querySelector('[data-variant-selects]');
  var variantData = [];
  if (selects) {
    try {
      variantData = JSON.parse(selects.querySelector('[data-variant-data]').textContent);
    } catch (e) {
      variantData = [];
    }
  }

  var idInput = root.querySelector('[data-variant-id]');
  var priceEl = root.querySelector('[data-price]');
  var availabilityEl = root.querySelector('[data-availability]');
  var atcBtn = root.querySelector('[data-atc]');
  var atcText = root.querySelector('[data-atc-text]');
  var stickyPriceEl = root.querySelector('[data-sticky-price]');
  var stickyBtn = root.querySelector('[data-sticky-atc-button]');
  var stickyText = root.querySelector('[data-sticky-atc-text]');

  /* ---------------- Piece-unique: "already in cart" ----------------
     A piece-unique product (real stock tracking on, not tagged "reassort"
     — see sections/main-product.liquid) can only ever be bought once, so
     once it's in the cart the add button must stop offering to add it
     again rather than silently incrementing past the real stock of 1. */
  var buyForm = root.querySelector('.product__form');
  var isPieceUnique = !!(buyForm && buyForm.getAttribute('data-piece-unique') === 'true');
  // Captured once, before anything here mutates the button: true only when
  // Liquid rendered it disabled because the variant is genuinely sold out
  // (current_variant.available == false). The "already in cart" state must
  // never override that — it stays authoritative.
  var isSoldOut = !!(atcBtn && atcBtn.disabled);

  function setInCartState(inCart) {
    if (!atcBtn || !atcText || isSoldOut) return;
    if (inCart) {
      atcBtn.setAttribute('disabled', 'disabled');
      atcText.textContent = atcBtn.getAttribute('data-label-in-cart') || 'Déjà dans votre panier';
    } else {
      atcBtn.removeAttribute('disabled');
      atcText.textContent = atcBtn.getAttribute('data-label-add') || 'Ajouter au panier';
    }
    if (stickyBtn && stickyText) {
      stickyBtn.disabled = atcBtn.disabled;
      stickyText.textContent = atcText.textContent;
    }
  }

  function checkAlreadyInCart() {
    if (!isPieceUnique || !idInput) return;
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var variantId = parseInt(idInput.value, 10);
        var inCart = cart.items.some(function (it) {
          return it.variant_id === variantId;
        });
        setInCartState(inCart);
      })
      .catch(function () {});
  }

  if (isPieceUnique) {
    checkAlreadyInCart();
    document.addEventListener('oxalis:cart:change', checkAlreadyInCart);
  }

  /* ---------------- Gift card: "send as a gift" recipient form ----------------
     The checkbox's own name/value is the real cart-line-item property
     Shopify's checkout looks for; the fields below it are real properties
     too (see sections/main-product.liquid). This just enables/reveals them
     when checked (so an unchecked box submits nothing) and hides the
     accelerated "Shop Pay" button meanwhile, since dynamic checkout
     bypasses the cart and would drop the properties entirely. */
  var giftRecipient = root.querySelector('[data-gift-recipient]');
  if (giftRecipient) {
    var recipientCheckbox = giftRecipient.querySelector('[data-recipient-checkbox]');
    var recipientFields = giftRecipient.querySelector('[data-recipient-fields]');
    var recipientInputs = giftRecipient.querySelectorAll('[data-recipient-input]');
    var recipientEmail = giftRecipient.querySelector('input[name="properties[Recipient email]"]');
    var dynamicCheckout = root.querySelector('[data-dynamic-checkout]');

    if (recipientCheckbox && recipientFields) {
      recipientCheckbox.addEventListener('change', function () {
        var on = recipientCheckbox.checked;
        recipientFields.hidden = !on;
        recipientInputs.forEach(function (el) {
          el.disabled = !on;
        });
        if (recipientEmail) recipientEmail.required = on;
        if (dynamicCheckout) dynamicCheckout.hidden = on;
      });
    }
  }

  function currentOptions() {
    var opts = [];
    root.querySelectorAll('[data-variant-selects] fieldset').forEach(function (fs) {
      var checked = fs.querySelector('input:checked');
      if (checked) opts.push(checked.value);
    });
    return opts;
  }

  function findVariant(opts) {
    return variantData.find(function (v) {
      return v.options.every(function (o, i) {
        return o === opts[i];
      });
    });
  }

  function updateVariant() {
    var opts = currentOptions();
    root.querySelectorAll('[data-variant-selects] label').forEach(function (l) {
      l.classList.toggle('is-active', l.querySelector('input').checked);
    });

    // Primary path: the checked radio carries the real variant id directly
    // (option_value.variant.id, rendered server-side) — exact and instant
    // for every single-option product on this site (all of them today:
    // chain extension, gift card denominations). Falls back to matching
    // by option strings only for a hypothetical future multi-option
    // product, where a single option value can't identify one variant.
    var checkedWithVariant = root.querySelector('[data-variant-selects] input:checked[data-option-variant-id]');
    var variant = null;
    if (checkedWithVariant && checkedWithVariant.getAttribute('data-option-variant-id')) {
      var vid = parseInt(checkedWithVariant.getAttribute('data-option-variant-id'), 10);
      variant = variantData.find(function (v) {
        return v.id === vid;
      });
    }
    if (!variant) variant = findVariant(opts);
    if (!variant) return;

    if (idInput) idInput.value = variant.id;

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    if (priceEl) {
      priceEl.innerHTML = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.innerHTML +=
          ' <s class="price__was">' + formatMoney(variant.compare_at_price) + '</s>';
      }
    }

    if (atcBtn && atcText) {
      if (variant.available) {
        atcBtn.removeAttribute('disabled');
        atcText.textContent = atcBtn.getAttribute('data-label-add') || 'Ajouter au panier';
      } else {
        atcBtn.setAttribute('disabled', 'disabled');
        atcText.textContent = atcBtn.getAttribute('data-label-soldout') || 'Épuisé';
      }
    }

    // Sticky bar mirrors the real button/price exactly — copied, not
    // recomputed, so the two can never disagree.
    if (stickyPriceEl && priceEl) stickyPriceEl.innerHTML = priceEl.innerHTML;
    if (stickyBtn && stickyText && atcBtn && atcText) {
      stickyBtn.disabled = atcBtn.disabled;
      stickyText.textContent = atcText.textContent;
    }

    if (variant.featured_media && variant.featured_media.id) {
      showMedia(variant.featured_media.id);
    }

    updateJoncGallery();
  }

  /* ---------------- Jonc fleuri: combination-aware gallery ----------------
     Self-contained reactive layer on top of the generic variant logic
     above — both lookups here only ever match a Jonc fleuri product
     (sections/main-product.liquid only renders data-option-name="Couleur
     du métal" / "Inclusions de feuilles d'or" there), so this is a no-op
     everywhere else: metalFieldset is null and the function returns
     immediately.

     2026-10, galeries dynamiques: a photo's real identity is the FULL
     combination (metal AND inclusions together, e.g. "dore-sans"), not
     the metal alone — mirrors sections/main-product.liquid's own
     current_combo. There is deliberately no fallback to a different
     combination's real photos any more (that would present one finish/
     inclusion as if it were another); a combination with nothing tagged
     for it shows the single, clearly-labelled placeholder slide the
     section always renders (data-combo-placeholder) instead. */
  var metalFieldset = root.querySelector('[data-option-name="Couleur du métal"]');
  var inclusionsFieldset = root.querySelector('[data-option-name="Inclusions de feuilles d\'or"]');
  var METAL_TO_KEY = { Doré: 'dore', Argenté: 'argente' };

  function updateJoncGallery() {
    if (!metalFieldset) return;
    var metalChecked = metalFieldset.querySelector('input:checked');
    var metalKey = metalChecked ? METAL_TO_KEY[metalChecked.value] : null;
    if (!metalKey) return;
    var inclKey = 'avec';
    if (inclusionsFieldset) {
      var inclChecked = inclusionsFieldset.querySelector('input:checked');
      if (inclChecked && inclChecked.value === "Sans feuilles d'or") inclKey = 'sans';
    }
    var wanted = metalKey + '-' + inclKey;

    var comboSlides = slides.filter(function (s) {
      return s.getAttribute('data-combo') === wanted;
    });
    var hasComboMedia = comboSlides.length > 0;
    var placeholder = slides.filter(function (s) {
      return s.hasAttribute('data-combo-placeholder');
    })[0];

    slides.forEach(function (s) {
      var sc = s.getAttribute('data-combo');
      if (sc) {
        s.hidden = sc !== wanted;
      } else if (s.hasAttribute('data-combo-placeholder')) {
        s.hidden = hasComboMedia;
      }
    });
    thumbs.forEach(function (t) {
      var tc = t.getAttribute('data-combo');
      t.hidden = !!(tc && tc !== wanted);
    });

    if (hasComboMedia) {
      showMedia(comboSlides[0].getAttribute('data-media-id'));
    } else if (placeholder) {
      showMedia(placeholder.getAttribute('data-media-id'));
    }

    if (galleryCounter) {
      var visibleCount = hasComboMedia ? comboSlides.length : 1;
      galleryCounter.textContent = '1 / ' + visibleCount;
    }

    // Matière & dimensions still only varies by metal, not by inclusions —
    // unaffected by which combination has photos or not.
    root.querySelectorAll('[data-metal-finish]').forEach(function (el) {
      el.hidden = el.getAttribute('data-metal-finish') !== metalKey;
    });
  }

  function formatMoney(cents) {
    var value = (cents / 100).toLocaleString('fr-BE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return value + ' €';
  }

  if (selects) {
    selects.addEventListener('change', updateVariant);
  }

  /* ---------------- Add to cart (AJAX) ---------------- */
  var form = root.querySelector('.product__form');

  function performAdd(formData) {
    var btn = form.querySelector('[data-atc]');
    var original = atcText ? atcText.textContent : '';
    if (atcText) atcText.textContent = '…';
    if (btn) btn.setAttribute('disabled', 'disabled');
    // Mirror the pending state onto the sticky bar too — whichever button
    // triggered this submit, both stay in sync and a second tap on either
    // one is blocked the same way.
    if (stickyBtn) stickyBtn.disabled = true;
    if (stickyText) stickyText.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (item) {
        if (item && item.id) {
          document.dispatchEvent(
            new CustomEvent('oxalis:cart:add', { detail: { item: item } })
          );
          if (atcText) atcText.textContent = '✓';
          if (stickyText) stickyText.textContent = '✓';
          window.setTimeout(function () {
            if (isPieceUnique) {
              // Now genuinely in the cart — stays "Déjà dans votre panier"
              // rather than reopening the door to a second add.
              setInCartState(true);
              return;
            }
            if (atcText) atcText.textContent = original;
            if (btn) btn.removeAttribute('disabled');
            if (stickyText) stickyText.textContent = original;
            if (stickyBtn) stickyBtn.disabled = false;
          }, 1500);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () {
        window.location.href = '/cart';
      });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (isPieceUnique && atcBtn && atcBtn.disabled) return; // already in cart or sold out

      // Jonc fleuri: made to order, capped at 10 exemplaires per *model*
      // (product id) per order, combining every Couleur du métal /
      // Inclusions variant — never just this one variant's own quantity.
      // Shopify Basic has no native cross-variant order rule, so this is
      // the theme doing its best at the only moment the real existing
      // cart total is knowable; it is not a hard server-side guarantee.
      var modelMax = qtyInput ? qtyInput.getAttribute('data-model-max-qty') : null;
      var qtyNote = root.querySelector('[data-jonc-qty-note]');
      if (modelMax && productIdAttr) {
        var requested = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            var pid = parseInt(productIdAttr, 10);
            var existing = cart.items.reduce(function (sum, it) {
              return it.product_id === pid ? sum + it.quantity : sum;
            }, 0);
            var room = parseInt(modelMax, 10) - existing;
            if (room <= 0) {
              if (qtyNote) qtyNote.hidden = false;
              return;
            }
            if (qtyNote) qtyNote.hidden = true;
            var fd = new FormData(form);
            fd.set('quantity', Math.min(requested, room));
            performAdd(fd);
          })
          .catch(function () {
            performAdd(new FormData(form));
          });
        return;
      }

      performAdd(new FormData(form));
    });
  }

  /* ---------------- Sticky add-to-cart bar (mobile/tablette) ----------------
     Visibility is driven purely by whether the real button is on screen —
     no scroll-position maths. Tapping the sticky button submits the very
     same form as the real one (no separate cart/variant logic that could
     ever disagree with it); CSS hides the bar entirely on desktop. */
  var stickyBar = root.querySelector('[data-sticky-atc]');
  if (stickyBar && stickyBtn && atcBtn && form) {
    stickyBtn.addEventListener('click', function () {
      if (atcBtn.disabled) return; // mirrors the real button's own guard
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      }
    });

    if ('IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            stickyBar.hidden = entry.isIntersecting;
          });
        },
        { threshold: 0 }
      );
      stickyObserver.observe(atcBtn);
    }
  }

  /* ---------------- Recommendations ---------------- */
  var rec = document.querySelector('[data-recommendations]');
  if (rec) {
    var url = rec.getAttribute('data-url');
    fetch(url)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-recommendations-grid]');
        var target = rec.querySelector('[data-recommendations-grid]');
        if (grid && target && grid.innerHTML.trim()) {
          target.innerHTML = grid.innerHTML;
        } else {
          rec.remove();
        }
      })
      .catch(function () {
        rec.remove();
      });
  }
})();
